import React, { Component } from 'react';
import { localize } from 'react-localize-redux';
import { Field, reduxForm, reset, submit } from 'redux-form';
import { TextField } from 'redux-form-material-ui';
import { connect } from 'react-redux';
import FlatButton from 'material-ui/FlatButton';
import { AccentColor } from 'helpers/AccentColorHelper';
import { colors } from 'helpers/ColorHelper';
import TenantResidentVerbiageHelper from 'components/shared/TenantResidentVerbiageHelper';
import EventTimeline from 'components/shared/EventTimeline';
import { submitNote, getTenantNotes, clearTenantNotes } from 'actions/landlordTenantsActions';
import * as validator from 'helpers/Validator';

import Header from 'components/shared/Header';

import withMobileDialog from '@material-ui/core/withMobileDialog';

let TenantNotesForm = class extends Component {
  render() {
    return (
      <form onSubmit={this.props.handleSubmit}>
        <div className="row">
          <div className="col-xs-12" style={{ margin: 'auto', textAlign: 'initial' }}>
            <Field
              name="text"
              component={TextField}
              style={{ fontSize: '14px' }}
              validate={[validator.required]}
              floatingLabelText={
                this.props.translate('landlordPortal.tenantNotes.notes').props.children
              }
              fullWidth
              multiLine
              rows={2}
            />
          </div>
        </div>
        <div className="row" style={{ textAlign: 'center', margin: '5px 0 15px' }}>
          <FlatButton
            label={this.props.translate('landlordPortal.tenantNotes.addNote').props.children}
            onClick={() => this.props.remoteSubmit('tenant_notes')}
            style={{
              backgroundColor: this.props.submitting ? colors.GRAY : AccentColor(),
              color: '#fff',
            }}
            disabled={this.props.submitting}
          />
        </div>
        <Header
          name={this.props.translate('landlordPortal.tenantNotes.notesUpcase').props.children}
        />
      </form>
    );
  }
};
TenantNotesForm = reduxForm({
  form: 'tenant_notes',
})(localize()(TenantNotesForm));

let TenantNotesDialogContent = class extends Component {
  componentDidMount() {
    const leadID = this.props.leadID;
    this.props.getTenantNotes(leadID);
  }

  componentWillUnmount() {
    this.props.clearTenantNotes();
  }

  createTenantNote = tenantNote => {
    const leadID = this.props.leadID;
    return this.props.submitNote(tenantNote, leadID).then(() => {
      this.props.reset('tenant_notes');
      this.props.getTenantNotes(leadID);
    });
  };

  render() {
    return (
      <div>
        <Header
          name={this.props.translate('landlordPortal.tenantNotes.addNoteUpcase').props.children}
        />
        <TenantNotesForm onSubmit={this.createTenantNote} remoteSubmit={this.props.remoteSubmit} />
        {this._renderTenantNotes()}
        {this._renderTenantNoNotes()}
      </div>
    );
  }

  _renderTenantNotes = () => {
    if (this.props.tenantNotes.length === 0) return;

    return <EventTimeline events={this.props.tenantNotes} />;
  };

  _renderTenantNoNotes = () => {
    if (this.props.tenantNotes.length !== 0) return;

    return (
      <div className="row" style={{ padding: '15px 0' }}>
        <p style={{ textAlign: 'center' }}>
          {this.props.translate('landlordPortal.tenantNotes.noNotes')}{' '}
          <TenantResidentVerbiageHelper />.
        </p>
      </div>
    );
  };
};
TenantNotesDialogContent = connect(
  store => ({
    tenantNotes: store.landlordTenants.tenantNotes,
    tenantDetails: store.landlordTenants.tenantDetails,
  }),
  {
    remoteSubmit: submit,
    getTenantNotes,
    clearTenantNotes,
    submitNote,
    reset,
  }
)(localize()(TenantNotesDialogContent));

let TenantNotes = class extends Component {
  constructor(props) {
    super(props);
    this.state = { dialogOpen: false };
  }
  render() {
    return (
      <div className="row">
        <TenantNotesDialogContent leadID={this.props.leadID} />
      </div>
    );
  }
};
export default withMobileDialog()(TenantNotes);
